import { CategoriesTiles } from './CategoriesTiles';
import { CategoriesTilesSlots } from './CategoriesTilesSlots';

const CategoriesTilesNamespace = CategoriesTiles as typeof CategoriesTiles & {
  Header: typeof CategoriesTilesSlots.Header;
};

CategoriesTilesNamespace.Header = CategoriesTilesSlots.Header;

export { CategoriesTilesNamespace as CategoriesTiles };
export type { CategoriesTilesProps, TileItem } from './types';
